import { useTranslation } from 'react-i18next';

import { ReportCategory, Report } from '../types';
import { REPORT_NAMES } from '../constants';
import {
  useWorkOrderTenantSurveysEnabled,
  usePMTaskAutoExpirationEnabled,
} from 'react-hooks';

export function useReports() {
  const { t } = useTranslation();

  const isWorkOrderTenantSurveysEnabled = useWorkOrderTenantSurveysEnabled();
  const isPMTaskAutoExpirationEnabled = usePMTaskAutoExpirationEnabled();
  const serviceRequestReports: Report[] = [
    {
      id: REPORT_NAMES.SERVICE_REQUESTS_SUMMARY,
      displayName: t('web.admin.workOrder.reporting.serviceRequestsSummary'),
    },
    {
      id: REPORT_NAMES.SERVICE_REQUEST_COMPLETION_TIME,
      displayName: t(
        'web.admin.workOrder.reporting.serviceRequestCompletionTime'
      ),
    },
    {
      id: REPORT_NAMES.SERVICE_REQUEST_RESPONSE_TIME,
      displayName: t(
        'web.admin.workOrder.reporting.serviceRequestResponseTime'
      ),
    },
    {
      id: REPORT_NAMES.SERVICE_REQUEST_ACCEPTANCE_TIME,
      displayName: t(
        'web.admin.workOrder.reporting.serviceRequestAcceptanceTime'
      ),
    },
  ];

  const preventiveMaintenanceReports: Report[] = [
    {
      id: REPORT_NAMES.PREVENTIVE_MAINTENANCE_TASKS_SUMMARY,
      displayName: t('web.admin.workOrder.reporting.pmTasksSummary'),
    },
    {
      id: REPORT_NAMES.PREVENTIVE_MAINTENANCE_TIME_EVALUATION_BY_TASK,
      displayName: t(
        'web.admin.workOrder.reporting.preventiveMaintenanceTimeEvaluationByTask'
      ),
    },
  ];

  if (isPMTaskAutoExpirationEnabled) {
    preventiveMaintenanceReports.push(
      {
        id: REPORT_NAMES.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_PROPERTY,
        displayName: t(
          'web.admin.workOrder.reporting.preventiveMaintenanceTaskPerformanceByProperty'
        ),
      },
      {
        id: REPORT_NAMES.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_USER,
        displayName: t(
          'web.admin.workOrder.reporting.preventiveMaintenanceTaskPerformanceByAssignedUser'
        ),
      },
      {
        id: REPORT_NAMES.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_ASSIGNED_TEAM,
        displayName: t(
          'web.admin.workOrder.reporting.preventiveMaintenanceTaskPerformanceByAssignedTeam'
        ),
      },
      {
        id: REPORT_NAMES.PREVENTIVE_MAINTENANCE_TASK_PERFORMANCE_BY_SCHEDULE,
        displayName: t(
          'web.admin.workOrder.reporting.preventiveMaintenanceTaskPerformanceBySchedule'
        ),
      }
    );
  }

  if (isWorkOrderTenantSurveysEnabled) {
    serviceRequestReports.push({
      id: REPORT_NAMES.SERVICE_REQUEST_TENANT_SURVEY_SUMMARY,
      displayName: t(
        'web.admin.workOrder.reporting.serviceRequestTenantSurveySummary'
      ),
    });
  }

  const reportCategories: ReportCategory[] = [
    {
      id: 'standard-service-request-reports',
      title: t('web.admin.workOrder.reporting.standardSRReports'),
      reports: serviceRequestReports,
    },
    {
      id: 'standard-preventive-maintenance-reports',
      title: t('web.admin.workOrder.reporting.standardPMReports'),
      reports: preventiveMaintenanceReports,
    },
  ];

  return { reportCategories };
}
